import { useCallback, useState } from "react";
import { ApiError } from "../api/client";

type ErrorMessage = string | ((error: unknown) => string);

export function useMutation<TArgs extends unknown[], TResult>(
  mutationFn: (...args: TArgs) => Promise<TResult>,
  errorMessage: ErrorMessage,
) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const mutate = useCallback(
    async (...args: TArgs): Promise<TResult | null> => {
      setLoading(true);
      setError(null);
      try {
        return await mutationFn(...args);
      } catch (err) {
        setError(
          err instanceof ApiError
            ? err.message
            : typeof errorMessage === "function"
              ? errorMessage(err)
              : errorMessage,
        );
        return null;
      } finally {
        setLoading(false);
      }
    },
    [errorMessage, mutationFn],
  );

  return { mutate, loading, error, setError };
}
